<template>
	<div class="">
		<div class="header">
			<div class="logo_soc">
				<a @click="irApantallaPrincipal()" style="cursor: pointer"> <img src="../assets/images/logo/logo-soc.png" alt="Logo" class="" width="160" /></a>
			</div>
			<div class="logo_eje">
				<!--este es el logo del broker-->
				<img :src="'https://cotizador.socasesores.com/uploads/' + logoHeader" alt="Logo" class="logo" />
			</div>
		</div>
		<!--<logo-broker/>  este es el componente para el logo dle broker-->
		<div>
			<!--<tab-content >-->
			<div class="wizard-tab-content" id="contacto">
				<div class="card-form" vs-w="8">
					<div class="row row-form align-title">
						<div class="navigation-circle alinear">1</div>
						<div class="col-md-10 col-sm-12 title">Para encontrar las mejores opciones, platícanos de ti</div>
					</div>
					<div class="card-content">
						<vs-row class="row-form">
							<label class="label-lg">¿Cómo te llamas?</label>
							<vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="margin-col">
								<vs-input v-model="name" v-validate="'required|alpha_spaces'" name="name" placeholder="Mi nombre es…" />
								<span class="text-danger text-sm" v-show="errors.has('name')">Campo requerido</span>
							</vs-col>
							<vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="margin-col">
								<vs-input class=" " v-model="firstname" v-validate="'required|alpha_spaces'" name="firstname" placeholder="Mi apellido paterno es…" />
								<span class="text-danger text-sm" v-show="errors.has('firstname')">Campo requerido</span>
							</vs-col>
							<vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="margin-col">
								<vs-input class="" v-model="lastname" v-validate="'required|alpha_spaces'" name="lastname" placeholder="Mi apellido materno es…" />
								<span class="text-danger text-sm" v-show="errors.has('lastname')">Campo requerido</span>
							</vs-col>
						</vs-row>
						<vs-row class="row-form">
							<vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="margin-col">
								<vs-input class="" label="¿Cuál es tu teléfono celular?" v-model="phone" v-validate="'required|min:14|max:14'" maxlength="14" minlengeth="14" name="phone" v-on:keypress="isNumber($event)" placeholder="55 0000 0000" />
								<span class="text-danger text-sm" v-show="errors.has('phone')">Campo requerido</span>
							</vs-col>
						</vs-row>
						<vs-row class="row-form">
							<vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="margin-col">
								<vs-input class="mt-1" label="¿Cuál es tu correo electrónico?" v-model="mail" name="email" v-validate="'required|email'" placeholder="nombre@mail.com" />
								<span class="text-danger text-sm" v-show="errors.has('email')">El campo debe ser un correo electrónico válido</span>
								<span class="text-danger text-sm" v-if="emailState2">*No se permite ingresar correos con dominio de SOC</span>
							</vs-col>
						</vs-row>
					</div>
				</div>

				<vs-row class="card-content">
					<vs-button class="col-md-3" @click="createSolicitante()" :disabled="!completeInfo">Siguiente</vs-button>
				</vs-row>
			</div>
			<!--<Contacto v-on:nextTab="next($event);"/>-->
			<br />
			<!--</tab-content>
        <tab-content :icon="null">-->
			<!--<Destinos  :destino="destino"  v-on:updateDestino="update($event)"/>-->
			<div class="" id="destinos" :hidden="true">
				<div id="">
					<div class="wizard-tab-content">
						<div class="row-form alinear">
							<div class="navigation-circle">2</div>
							<label class="fill_name" type="text">{{ name }}</label
							><span class="coma">,</span>
							<span class="title"><span class="ocultar">,</span>&nbsp; ¿para qué usarás el crédito?</span>
						</div>
						<div class="card-content">
							<div class="row-form">
								<input class="mr-4" type="radio" id="1" value="1" v-model="caso.destino" />
								<label class="pago" for="Adquisición origen vivienda">Adquisición origen vivienda</label>
							</div>
							<div class="row-form">
								<input class="mr-4" type="radio" id="3" value="3" v-model="caso.destino" />
								<label class="pago" for="Liquidez">Liquidez </label>
							</div>
							<div class="row-form">
								<input class="mr-4" type="radio" id="5" value="5" v-model="caso.destino" />
								<label class="pago" for="Adquisición de Terreno">Adquisición origen terreno</label>
							</div>
							<div class="row-form">
								<input class="mr-4" type="radio" id="19" value="19" v-model="caso.destino" />
								<label class="pago" for="Mejora de hipoteca">Mejora hipoteca origen vivienda</label>
							</div>
						</div>
						<div class="card-content">
							<div class="d-flex justify-content-between">
								<button class="btn btn-exportar" @click="regresar('contacto')">
									<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M15.334 11.675L12.148 14.861L15.334 18.047" stroke="#006D4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M24.892 14.861L12.234 14.861" stroke="#006D4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path opacity="0.4" d="M14.9349 24.892C9.43494 24.892 4.97794 21.158 4.97794 14.935C4.97794 8.71201 9.43493 4.97801 14.9349 4.97801" stroke="#006D4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg
									><strong>Regresar</strong>
								</button>
								<vs-button class="col-md-3" @click="avanza('destinos')">Siguiente</vs-button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<br />
			<!--</tab-content>
        <tab-content :icon="null">-->
			<!--<Credito :destino="destino"  v-if="destino!='' && !resultados" v-on:updateCredito="updateCredito($event);"/>-->
			<div id="credito" :hidden="true">
				<div>
					<div class="wizard-tab-content-destinos">
						<div class="row-form alinear">
							<div class="navigation-circle">3</div>
							<label class="fill_name" type="text">{{ name }}</label
							><span class="coma">,</span>
							<span class="title"><span class="ocultar">,</span>&nbsp;define las características del crédito:</span>
						</div>
						<div class="card-content">
							<div class="row row-form" v-if="caso.destino != 5">
								<vs-col vs-lg="6" vs-sm="12" vs-xs="12">
									<vs-input class="w-full mt-1" label="Valores de vivienda" v-model="valores.valor" name="username" v-on:focusout="validamonto()" v-on:keypress="isNumber($event)" placeholder="$X,XXX,XXX.XX" />
								</vs-col>
							</div>
							<div class="row row-form" v-if="caso.destino == 5">
								<vs-col vs-lg="6" vs-sm="12" vs-xs="12">
									<vs-input class="w-full mt-1" label="Valor del terreno" v-model="valores.valor" name="username" v-on:focusout="validamonto()" v-on:keypress="isNumber($event)" placeholder="$X,XXX,XXX.XX" />
								</vs-col>
							</div>
							<div class="row row-form" v-if="caso.destino != 19">
								<vs-col vs-lg="6" vs-sm="12" vs-xs="12">
									<vs-input class="w-full mt-1" label="Monto de crédito" v-model="valores.credito" name="valorCredito" @change="validacreditomonto()" v-on:keypress="isNumber($event)" placeholder="$X,XXX,XXX.XX" />
								</vs-col>
							</div>
							<div class="row row-form" v-if="caso.destino == 19">
								<vs-col vs-lg="6" vs-sm="12" vs-xs="12">
									<vs-input class="w-full mt-1" label="Restante por pagar" v-model="valores.credito" name="username" @change="validacreditomonto()" v-on:keypress="isNumber($event)" placeholder="$X,XXX,XXX.XX" />
								</vs-col>
							</div>
							<div class="row row-form" v-if="caso.destino == 19">
								<vs-col vs-lg="6" vs-sm="12" vs-xs="12">
									<vs-input class="w-full mt-1" label="Pago mensual" v-model="valores.mensualidad" name="username" v-on:keypress="isNumber($event)" @change="validamensualidad()" placeholder="$X,XXX,XXX.XX" />
								</vs-col>
							</div>

							<div class="row row-form" v-if="caso.destino == 19">
								<vs-col vs-lg="6" vs-sm="12" vs-xs="12">
									<label class="">Tiempo restante en el crédito</label>

									<v-select name="tiempo_restante" v-model="valores.plazoRestante" :options="plazos" />
								</vs-col>
							</div>
							<div class="row row-form">
								<vs-col vs-lg="6" vs-sm="12" vs-xs="12">
									<label>Plazos a cotizar</label>
									<v-select name="plazos" v-model="valores.plazosACotizar" @input="cambiaBancos()" multiple :options="plazos" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
								</vs-col>
							</div>
							<div class="row row-form">
								<label class="row-form">Esquemas de pago</label>
								<div class="row alinear">
									<div class="col-md-4">
										<input type="checkbox" id="1" value="1" v-model="valores.esquemasACotizar" class="mr-1" @change="validaplazos(), cambiaBancos()" />
										<label for="Pago Fijo">Pago Creciente</label>
									</div>
									<div class="col-md-4">
										<input type="checkbox" @change="validaplazos(), cambiaBancos()" id="2" value="2" v-model="valores.esquemasACotizar" class="mr-1" />
										<label for="Pago Fijo">Pago Fijo</label>
									</div>
									<!--
                      <v-select v-model="valores.esquemasACotizar" multiple :closeOnSelect="false" :options="esquemas" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>  
                    -->
								</div>
							</div>

							<div class="row row-form">
								<vs-col vs-lg="6" vs-sm="12" vs-xs="12">
									<label>Bancos</label>
									<v-select v-model="caso.bancos" multiple :closeOnSelect="false" :options="bancos" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
								</vs-col>
							</div>
						</div>
						<div class="card-content">
							<div class="d-flex justify-content-between">
								<button class="btn btn-exportar" @click="regresar('destinos')">
									<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M15.334 11.675L12.148 14.861L15.334 18.047" stroke="#006D4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path d="M24.892 14.861L12.234 14.861" stroke="#006D4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										<path opacity="0.4" d="M14.9349 24.892C9.43494 24.892 4.97794 21.158 4.97794 14.935C4.97794 8.71201 9.43493 4.97801 14.9349 4.97801" stroke="#006D4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg
									><strong>Regresar</strong>
								</button>
								<!-- <div class="row row-form" v-if="caso.destino!=19"> -->
								<vs-button class="col-md-3" v-if="caso.destino != 19" @click="avanza('credito')" :disabled="!completeInfoCredito">Siguiente</vs-button>
								<!--  </div> -->
								<!--  <div class="row row-form" v-if="caso.destino==19"> -->
								<vs-button class="col-md-3" v-if="caso.destino == 19" @click="avanza('credito')" :disabled="!completeInfoCredito19">Siguiente</vs-button>
								<!--  </div> -->
							</div>
						</div>
					</div>

					<!--<Adquisicion v-on:updateValores="update($event)" v-if="caso.destino==1"/>-->
					<!--<Terreno v-on:updateValores="update($event)" v-if="caso.destino==5"/>
            <Mejora v-on:updateValores="update($event)" v-if="caso.destino==19"/>
            <Liquidez v-on:updateValores="update($event)" v-if="caso.destino==3"/>-->
				</div>
				<br />
			</div>
			<br />
			<!--</tab-content>
        <tab-content :icon="null" >-->
			<!--<Resultados   v-if="resultados" v-on:nextTab="next($event);"/>-->
			<div class="wizard-tab-content" id="resultados" :hidden="true">
				<button class="btn btn-exportar p-0 mb-4" @click="regresar('credito')">
					<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M15.334 11.675L12.148 14.861L15.334 18.047" stroke="#006D4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M24.892 14.861L12.234 14.861" stroke="#006D4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
						<path opacity="0.4" d="M14.9349 24.892C9.43494 24.892 4.97794 21.158 4.97794 14.935C4.97794 8.71201 9.43493 4.97801 14.9349 4.97801" stroke="#006D4E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg
					><strong>Regresar</strong>
				</button>
				<div class="row-form alinear">
					<div class="navigation-circle">4</div>
					<label class="fill_name" type="text">{{ name }}</label
					><span class="coma">,</span>
					<span class="title"><span class="ocultar">,</span>&nbsp;las mejores alternativas para ti son:</span>
				</div>
				<div class="content-cards">
					<div v-for="item in items" :key="item.Id">
						<div class="card-resultados overflow-hidden">
							<div class="row">
								<div class="col-md-3 col-sm-12 alinear">
									<img :src="'https://cotizador.socasesores.com/uploads/' + item.Logo" :alt="item.Banco" width="140" class="image img-responsive" />
								</div>
								<div class="col-md-5 col-sm-12">
									<h6 class="producto">{{ item.Producto }}</h6>
									<div class="flex justify-between items-center">
										<h6 class="pago">Pago {{ item.Esquema == 2 ? 'Fijo' : 'Creciente' }} durante {{ item.Plazo / 12 }} años</h6>
									</div>
									<div class="my-4">
										<h6 class="mensualidad">Mensualidad ${{ numberFormat(item.MensualidadPromedio) }}</h6>
										<p class="pago item-description text-sm">Tasa {{ item.Tasa }}%</p>
										<p class="pago item-description text-sm">Cat {{ numberFormat(item.Cat) }}%</p>
									</div>
								</div>
								<div class="col-md-4 col-sm-12 alinear" v-if="item.Banco != 21">
									<button class="btn-producto" @click="elegirProducto(item)">Elegir producto</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<br />
			<!--</tab-content>
        <tab-content :icon="null">-->
			<div class="wizard-tab-content" id="seleccionado" :hidden="true">
				<div class="row">
					<h3 class="title"><center>Producto seleccionado</center></h3>
				</div>
				<div style="text-align: right">
					<img src="../assets/images/pages/check.svg" class="check" />
				</div>
				<div class="row" v-if="productoSeleccionado.Banco">
					<div class="card-producto">
						<div class="row">
							<div class="col-md-4 col-sm-12 alinear">
								<img :src="'https://cotizador.socasesores.com/uploads/' + productoSeleccionado.BancoLogo" :alt="productoSeleccionado.Banco" class="image img-responsive" />
							</div>
							<div class="col-md-8 col-sm-12">
								<h6 class="producto">{{ productoSeleccionado.Variante }}</h6>
								<div class="flex justify-between items-center">
									<h6 class="pago">Pago {{ productoSeleccionado.Esquema == 2 ? 'Fijo' : 'Creciente' }} durante {{ productoSeleccionado.Plazo }} años</h6>
								</div>
								<div class="my-4">
									<h6 class="mensualidad">Mensualidad ${{ numberFormat(productoSeleccionado.MensualidadPromedio) }}</h6>
									<p class="pago item-description text-sm">Tasa {{ productoSeleccionado.Tasa }}%</p>
									<p class="pago item-description text-sm">Cat {{ numberFormat(productoSeleccionado.Cat) }}%</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 col-sm-12">
						<center>
							<small class="pago">Tus datos y elección se han registrado de manera exitosa, pronto un asesor se pondrá en contacto contigo.</small>
						</center>
					</div>
				</div>
			</div>
			<br />
			<!--</tab-content>-->
		</div>
		<!--fin form wizard-->
	</div>
</template>

<script>
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'
import { FormWizard, TabContent, WizardStep, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
export default {
	data() {
		return {
			logoHeader: '',
			idCaso: '',
			plazos: [
				{ label: '20 Años', value: '20' },
				{ label: '19 Años', value: '19' },
				{ label: '18 Años', value: '18' },
				{ label: '17 Años', value: '17' },
				{ label: '16 Años', value: '16' },
				{ label: '15 Años', value: '15' },
				{ label: '14 Años', value: '14' },
				{ label: '13 Años', value: '13' },
				{ label: '12 Años', value: '12' },
				{ label: '11 Años', value: '11' },
				{ label: '10 Años', value: '10' },
				{ label: '9 Años', value: '9' },
				{ label: '8 Años', value: '8' },
				{ label: '7 Años', value: '7' },
				{ label: '6 Años', value: '6' },
				{ label: '5 Años', value: '5' },
				{ label: '4 Años', value: '4' },
				{ label: '3 Años', value: '3' },
				{ label: '2 Años', value: '2' },
				{ label: '1 Años', value: '1' },
			],
			esquemas: [
				{ label: 'Pago Fijo', value: '2' },
				{ label: 'Pago creciente', value: '1' },
			],
			valores: {
				destino: 1,
				valor: '',
				credito: '',
				mensualidad: '',
				plazoRestante: '',
				esquemasACotizar: ['2'],
				plazosACotizar: [{ label: '20 Años', value: '20' }],
			},
			destino: '',
			mail: '',
			name: '',
			lastname: '',
			firstname: '',
			phone: '',
			ejecutivo: '',
			destinos: [
				{ Id: 1, Nombre: 'Adquisición de vivienda' },
				{ Id: 3, Nombre: 'Liquidez' },
				{ Id: 5, Nombre: 'Adquisición de Terreno' },
				{ Id: 19, Nombre: 'Mejora de hipoteca' },
			],
			caso: {
				valor: '',
				credito: '',
				destino: 1,
				plazos: [],
				bancos: [],
				esquemas: [],
				mensualidad: '',
				plazoRestante: '',
			},
			items: [],
			bancosEjecutivo: [
				{ label: 'CITIBANAMEX', value: 2 },
				{ label: 'BANORTE', value: 4 },
				{ label: 'HSBC', value: 6 },
				{ label: 'SANTANDER', value: 10 },
				{ label: 'SCOTIABANK', value: 11 },
			],
			bancos: [],
			sendEmail: true,
			ejecutivo: '',
			casoCompleto: {},
			mostrarDestinos: true,
			mostrarDatosDestinos: false,
			productoSeleccionado: [],
			TipoEjecutivoV3: ''
		}
	},
	components: {
		FormWizard,
		TabContent,
		WizardStep,
		WizardButton,
		vSelect,
	},
	watch: {
		phone: function (newValue) {
			this.phone = newValue.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
		} /*
    valor: function(newValue) {
      if (typeof this.valores.valor == 'string') {
        this.valores.valor= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }else {
        this.valores.valor= newValue.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
    },
    credito: function(newValue) {
      if (typeof this.valores.credito == 'string') {
        this.valores.credito= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }else {
        this.valores.credito= newValue.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
    },*/,
	},
	mounted() {
		this.getApiKey(this.$route.params)
		this.key = this.$store.state.key
		this.getValues()
		this.getBancos()
	},
	computed: {
		...mapState(['casoId']),
		emailState2() {
			return this.mail.includes('socasesores') ? true : false
		},
		completeInfo() {
			return this.name != '' && this.lastname != '' && this.phone != '' && this.emailState && this.firstname != '' && !this.emailState2
		},
		validaValor() {
			var validava = this.valores.valor.replace('$', '')
			return parseFloat(validava) > 0
		},
		validaCredito() {
			var validacre = this.valores.credito.replace('$', '')
			return parseFloat(validacre) > 0
		},
		validaMensu() {
			var validamen = this.valores.mensualidad.replace('$', '')
			return parseFloat(validamen) > 0
		},
		completeInfoCredito() {
			return this.validaValor && this.validaCredito
		},
		completeInfoCredito19() {
			return this.validaValor && this.validaCredito && this.validaMensu
		},
		valor() {
			return this.valores.valor
		},
		credito() {
			return this.valores.credito
		},
		emailState() {
			const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			// const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			const matches = regex.test(this.mail)
			return matches
		},
	},
	methods: {
		...mapMutations(['getApiKey', 'getApiKey', 'saveSolicitante', 'savePhone', 'saveCasoId']),
		irApantallaPrincipal() {
			this.$router.go(0)
		},
		regresar(id) {
			switch (id) {
				case 'contacto':
					document.getElementById('contacto').removeAttribute('hidden')
					document.getElementById('destinos').hidden = true
					break
				case 'destinos':
					document.getElementById('destinos').removeAttribute('hidden')
					document.getElementById('credito').hidden = true
					break
				case 'credito':
					// this.update()
					document.getElementById('credito').removeAttribute('hidden')
					document.getElementById('resultados').hidden = true
					break
			}
		},
		avanza(id) {
			switch (id) {
				case 'destinos':
					document.getElementById('destinos').hidden = true
					document.getElementById('credito').removeAttribute('hidden')
					break
				case 'credito':
					this.update()
					document.getElementById('credito').hidden = true
					document.getElementById('resultados').removeAttribute('hidden')
					break
				case 'resultados':
					document.getElementById('resultados').hidden = true
					document.getElementById('seleccionado').removeAttribute('hidden')
					break
				/*case 'seleccionado':
          document.getElementById('seleccionado').hidden=true
          document.getElementById('seleccionado').removeAttribute('hidden')
          break;*/
			}
		},
		numberFormat(num) {
			return num
				.toFixed(2)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		},
    sendEmailToBroker(id){
      this.sendEmail=false

      const objEmail= {
				strApiKey: this.key,
        to: this.ejecutivo,
        email: this.mail,
        name: `${ this.name } ${ this.firstname } ${ this.lastname }`,
        phone: this.phone,
        id: id,
      }

      this.$vs.notify({
        title: 'Enviando correo electrónico a',
        text: this.ejecutivo,
        position:'top-right'
      })

      axios.post('https://pcotizador.socasesores.com:444/emailComparaleProd/widget.php',objEmail,{headers : {'Content-Type':'application/json; charset=UTF-8'}})
      .then(resp => {

        if ( resp.data.status ) {

          return this.$vs.notify({
            title: 'Ocurrio un error en',
            text: 'envio de correo',
            color: 'danger',
            position: 'top-right',
          })

        }

        this.$vs.notify({
          title: 'Se envió correctamente el correo electrónico a',
          text: this.ejecutivo,
          position:'top-right'
        })

      })
      .catch(function (error) {
        console.log(error);
      })
    },
		sendEmailToCliente(id){
      this.sendEmail=false

      const objEmail= {
				strApiKey: this.key,
        to: this.mail,
        ejecutivo: this.ejecutivo,
        name: this.name,
				firstname: this.firstname,
				lastname: this.lastname,
        phone: this.phone,
        id: id,
      }

      this.$vs.notify({
        title: 'Enviando correo electrónico a',
        text: this.mail,
        position:'top-right'
      })

      axios.post('https://pcotizador.socasesores.com:444/emailComparaleProd/widgetEmailCliente.php',objEmail,{headers : {'Content-Type':'application/json; charset=UTF-8'}})
				.then(resp => {

					if ( resp.data.status ) {

						return this.$vs.notify({
							title: 'Ocurrio un error en',
							text: 'envio de correo',
							color: 'danger',
							position: 'top-right',
						})

					}

					this.$vs.notify({
						title: 'Se envió correctamente el correo electrónico a',
						text: this.mail,
						position:'top-right'
					})

				})
				.catch(function (error) {
					console.log(error);
				})
    },
		sendEmailToSupervisor(id){
      this.sendEmail = false

      const objEmail= {
				strApiKey: this.key,
        broker: this.ejecutivo,
				solicitante: this.mail, 
        caso: id,
      }

      axios.post('https://pcotizador.socasesores.com:444/emailComparaleProd/widgetEmailSupervisor.php',objEmail,{headers : {'Content-Type':'application/json; charset=UTF-8'}})
				.then(resp => {

					if ( resp.data.status ) {

						return this.$vs.notify({
							title: 'Ocurrio un error en',
							text: 'envio de correo supervisor',
							color: 'danger',
							position: 'top-right',
						})

					}

				})
				.catch(function (error) {
					console.log(error);
				})
    },
		elegirProducto(item) {
			this.avanza('resultados')
			let self = this
			var objRequestSolicitaCaso = {
				strApiKey: this.key,
				strMetodo: 'Solicita',
				intVariante: item.Id,
				objCaso: {
					Id: this.casoId,
				},
			}
			this.$axios
				.post('/', objRequestSolicitaCaso, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {
					if (response.data.intEstatus == 0) {

						this.productoSeleccionado = response.data.objContenido
						const caso = response.data.objContenido.Caso

            this.sendEmailToBroker( caso )
            this.sendEmailToCliente( caso )

						if ( this.TipoEjecutivoV3 === 'Inmo' ) {

							this.sendEmailToSupervisor( caso )
							// console.log('Enviar correo a supervisor')

						}

						this.$vs.notify({
							title: `Solicitado exitosamente ${item.Id}`,
							text: `${item.Producto}`,
							position: 'top-right',
						})
					} else {
						this.$vs.notify({
							title: 'Ocurrio un error en Solicita',
							text: response.data.strError,
							color: 'danger',
							position: 'top-right',
						})
					}
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error de sistema',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
		update() {
			this.caso.plazos = []
			this.caso.esquemas = []

			for (var i = 0; i < this.valores.plazosACotizar.length; i++) {
				if (typeof this.valores.plazosACotizar[i] == 'object') {
					this.caso.plazos.push(this.valores.plazosACotizar[i].value)
				} else {
					this.caso.plazos.push(this.valores.plazosACotizar[i].substring(0, 2))
				}
			}
			for (var i = 0; i < this.valores.esquemasACotizar.length; i++) {
				this.caso.esquemas.push(parseInt(this.valores.esquemasACotizar[i]))
			}

			this.caso.valor = this.valores.valor
			this.caso.credito = this.valores.credito
			this.caso.mensualidad = this.valores.mensualidad
			this.caso.plazoRestante = this.valores.plazoRestante.value
			this.registrarCaso()
		},
		registrarCaso() {
			let self = this
			this.$vs.loading({
				container: '#resultados',
				scale: 0.6,
			})
			var objRequestRegistraCaso1 = {}
			if (typeof this.caso.valor == 'string') {
				this.caso.valor = this.caso.valor.replace(/,/g, '')
				this.caso.valor = this.caso.valor.replace('$', '')
			}
			if (typeof this.caso.credito == 'string') {
				this.caso.credito = this.caso.credito.replace(/,/g, '')
				this.caso.credito = this.caso.credito.replace('$', '')
			}
			if (typeof this.caso.mensualidad == 'string') {
				this.caso.mensualidad = this.caso.mensualidad.replace(/,/g, '')
				this.caso.mensualidad = this.caso.mensualidad.replace('$', '')
			}
			let bancos = []
			for (var i = 0; i < this.caso.bancos.length; i++) {
				bancos.push(parseInt(this.caso.bancos[i].value))
			}

			if (this.casoId) {
				if (this.caso.destino == '19') {
					objRequestRegistraCaso1 = {
						strApiKey: this.key,
						strMetodo: 'RegistraCaso',
						objCaso: {
							Id: this.casoId,
							ValorInmueble: parseFloat(this.caso.valor),
							SaldoInsoluto: parseFloat(this.caso.credito),
							Plazos: this.caso.plazos,
							Solicitante: this.mail,
							Destino: this.caso.destino,
							Esquemas: this.caso.esquemas,
							PlazoRestante: this.caso.plazoRestante,
							PagoMensualActual: parseFloat(this.caso.mensualidad.replace(/,/g, '')),
							Bancos: bancos,
							VersionOrigen: 'Widget',
							StatusCaso: 'Nuevo',
						},
					}
				} else {
					objRequestRegistraCaso1 = {
						strApiKey: this.key,
						strMetodo: 'RegistraCaso',
						objCaso: {
							Id: this.casoId,
							ValorInmueble: parseFloat(this.caso.valor),
							MontoSolicitado: parseFloat(this.caso.credito),
							Plazos: this.caso.plazos,
							Solicitante: this.mail,
							Destino: this.caso.destino,
							Esquemas: this.caso.esquemas,
							Bancos: bancos,
							VersionOrigen: 'Widget',
							StatusCaso: 'Nuevo',
						},
					}
				}
			} else {
				if (this.caso.destino == '19') {
					objRequestRegistraCaso1 = {
						strApiKey: this.key,
						strMetodo: 'RegistraCaso',
						objCaso: {
							ValorInmueble: parseFloat(this.caso.valor),
							SaldoInsoluto: parseFloat(this.caso.credito),
							Plazos: this.caso.plazos,
							Solicitante: this.mail,
							Destino: this.caso.destino,
							Esquemas: this.caso.esquemas,
							PlazoRestante: this.caso.plazoRestante,
							PagoMensualActual: parseFloat(this.caso.mensualidad),
							Bancos: bancos,
							VersionOrigen: 'Widget',
							StatusCaso: 'Nuevo',
						},
					}
				} else {
					objRequestRegistraCaso1 = {
						strApiKey: this.key,
						strMetodo: 'RegistraCaso',
						objCaso: {
							ValorInmueble: parseFloat(this.caso.valor),
							MontoSolicitado: parseFloat(this.caso.credito),
							Plazos: this.caso.plazos,
							Solicitante: this.mail,
							Destino: this.caso.destino,
							Esquemas: this.caso.esquemas,
							Bancos: bancos,
							VersionOrigen: 'Widget',
							StatusCaso: 'Nuevo',
						},
					}
				}
			}
			this.$axios
				.post('/', objRequestRegistraCaso1, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {
					if (response.data.intEstatus == 0) {
						this.mostrarDestinos = false
						this.mostrarDatosDestinos = false
						this.saveCasoId(response.data.objContenido.Id)
						this.idCaso = response.data.objContenido.Id
						this.cotiza(this.idCaso)

            this.ejecutivo = response.data.objContenido.Broker
						//this.dameCaso(response.data.objContenido.Id)
						//this.$emit('updateCredito',true)
						//this.cotiza(response.data.objContenido.Id)
					} else {
						this.$vs.notify({
							title: 'Ocurrio un error en RegistraCaso',
							text: response.data.strError,
							color: 'danger',
							position: 'top-right',
						})
					}
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error en RegistraCaso',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
		cotiza(id) {
			let self = this
			let objRequestCotizaCaso = {
				strApiKey: this.key,
				strMetodo: 'Cotiza',
				objCaso: {
					Id: id,
				},
			}
			this.$axios
				.post('/', objRequestCotizaCaso, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {
					if (response.data.intEstatus == 0) {
						let esquemas = []

						for (var i = 0; i < this.caso.esquemas.length; i++) {
							if (this.caso.esquemas[i].value) {
								esquemas.push(parseInt(this.caso.esquemas[i].value))
							} else {
								esquemas.push(parseInt(this.caso.esquemas[i]))
							}
						}

						for (var j = 0; j < this.caso.plazos.length; j++) {
							if ((esquemas.includes(2) && (this.caso.destino == 1 || this.caso.destino == 3) && (this.caso.plazos[j] == 5 || this.caso.plazos[j] == 6 || this.caso.plazos[j] == 7 || this.caso.plazos[j] == 8 || this.caso.plazos[j] == 9 || this.caso.plazos[j] == 10 || this.caso.plazos[j] == 11 || this.caso.plazos[j] == 12 || this.caso.plazos[j] == 13 || this.caso.plazos[j] == 14 || this.caso.plazos[j] == 15 || this.caso.plazos[j] == 16 || this.caso.plazos[j] == 17 || this.caso.plazos[j] == 18 || this.caso.plazos[j] == 19 || this.caso.plazos[j] == 20)) || (esquemas.includes(2) && (this.caso.destino == 5 || this.caso.destino == 37) && (this.caso.plazos[j] == 5 || this.caso.plazos[j] == 6 || this.caso.plazos[j] == 7 || this.caso.plazos[j] == 8 || this.caso.plazos[j] == 9 || this.caso.plazos[j] == 10))) {
								// this.pruebaIon(this.caso.plazos[j], this.caso.destino)

								this.items = response.data.objContenido
								this.items.sort((a, b) => (a.MensualidadPromedio > b.MensualidadPromedio ? 1 : b.MensualidadPromedio > a.MensualidadPromedio ? -1 : 0))

								// this.$vs.loading({
								// 	container: '#resultados',
								// 	scale: 0.6,
								// })
							} else {
								this.items = response.data.objContenido
								this.items.sort((a, b) => (a.MensualidadPromedio > b.MensualidadPromedio ? 1 : b.MensualidadPromedio > a.MensualidadPromedio ? -1 : 0))
								this.$vs.loading.close('#resultados > .con-vs-loading')
							}
						} //for

						this.items = response.data.objContenido
						this.items.sort((a, b) => (a.MensualidadPromedio > b.MensualidadPromedio ? 1 : b.MensualidadPromedio > a.MensualidadPromedio ? -1 : 0))
						this.$vs.loading.close('#resultados > .con-vs-loading')
					} else {
						this.$vs.notify({
							title: 'Ocurrio un error en Cotiza',
							text: response.data.strError,
							color: 'danger',
							position: 'top-right',
						})
					}
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error en Cotizar',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
		getBancos() {
			this.bancos = this.bancosEjecutivo //cambio bancos
			this.caso.bancos = this.bancosEjecutivo //cambio bancos
		},
		isNumber: function (evt) {
			evt = evt ? evt : window.event
			var charCode = evt.which ? evt.which : evt.keyCode
			if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
				evt.preventDefault()
			} else {
				return true
			}
		},
		pruebaIon(plazo, destinoInt) {
			let self = this
			let destinoIon = ''
			let GastosInicialCalculado = ''
			let NombreProducto = ''
			let amount = ''
			let respuestaData = ''
			let calculoAforo = ''

			calculoAforo = (this.caso.credito.replace(/,/g, '') * 100) / this.caso.valor.replace(/,/g, '')

			//console.log('anali123'+destinoInt)
			switch (parseInt(destinoInt)) {
				case 1:
					destinoIon = 'REAL_ESTATE'
					GastosInicialCalculado = this.caso.valor.replace(/,/g, '') * 0.08
					NombreProducto = 'ION Adquisición Plus'
					break
				case 3:
					destinoIon = 'LIQUIDITY'
					GastosInicialCalculado = this.caso.valor.replace(/,/g, '') * 0.03
					NombreProducto = 'ION Liquidez Plus'
					break
				case 5:
					destinoIon = 'LAND'
					GastosInicialCalculado = this.caso.valor.replace(/,/g, '') * 0.08
					NombreProducto = 'ION Adquisición de Terreno Plus'
					break
				case 37:
					destinoIon = 'OFFICES_AND_STORES'
					GastosInicialCalculado = this.caso.valor.replace(/,/g, '') * 0.08
					NombreProducto = 'ION Oficinas y Locales Plus'
					break
			}
			// console.log('anali' + destinoInt)
			// console.log(destinoIon)
			var objGeneraCodigo = {
				person_type: 'NATURAL', //valor fijo
				product: destinoIon, //producto
				required_amount: { amount: this.caso.credito.replace(/,/g, ''), currency: 'MXN' }, // cantidad requerida
				monthly_income: { amount: 50000000, currency: 'MXN' }, //ingreso mensual valor fijo
				real_estate_value: { amount: this.caso.valor.replace(/,/g, ''), currency: 'MXN' }, //valor inmobiliario
				term: parseInt(plazo),
			}
			this.$axios
				.post('https://cotizador.socasesores.com/ApiION/MethodoIon.php', objGeneraCodigo, { headers: { 'Content-Type': 'application/json; charset=UTF-8' } })
				.then((response) => {
					if (response.data.intRespuesta == 0) {
						respuestaData = JSON.parse(response.data.objRespuesta)

						if (respuestaData.notification.level == 'ERROR') {
							this.$vs.loading.close('#resultados > .con-vs-loading')
							self.$vs.notify({
								title: 'error de ion lavel',
								text: error,
								color: 'danger',
								position: 'top-right',
							})
						} else if (respuestaData.message == 'Internal server error') {
							this.$vs.loading.close('#resultados > .con-vs-loading')
							self.$vs.notify({
								title: 'error de ion internal serve',
								text: error,
								color: 'danger',
								position: 'top-right',
							})
						} else {
							var respuestaIon = JSON.parse(response.data.objRespuesta)
							let itemsIon = {}
							let items = []
							let cantidadCotiza = items.length
							itemsIon.Cat = parseFloat(respuestaIon.data.cat)
							itemsIon.Mensualidad = parseFloat(respuestaIon.data.monthly_payment.amount)
							itemsIon.Tasa = parseFloat(respuestaIon.data.interest_rate)
							itemsIon.IngresoMinimo = parseFloat(respuestaIon.data.minimum_income) // parseFloat(respuestaIon.data.monthly_payment.amount)/33
							itemsIon.Enganche = parseFloat(this.caso.valor.replace(/,/g, '') - this.caso.credito.replace(/,/g, ''))
							itemsIon.GastosIniciales = parseFloat(respuestaIon.data.initial_expenses)
							itemsIon.Aforo = calculoAforo
							itemsIon.Plazo = respuestaIon.data.term * 12
							itemsIon.PagoTotal = parseFloat(respuestaIon.data.total_payment)
							itemsIon.MensualidadPromedio = parseFloat(respuestaIon.data.monthly_payment.amount)
							itemsIon.MensualidadInicial = parseFloat(respuestaIon.data.monthly_payment.amount)
							itemsIon.BancoId = 21
							itemsIon.Banco = 'ION'
							itemsIon.Producto = NombreProducto
							itemsIon.Esquema = 2
							itemsIon.Logo = 'LogoIon_130622.png'
							itemsIon.PdfAmortizacion = respuestaIon.data.amortization_table.file
							itemsIon.JsonAmortizacion = respuestaIon.data.amortization_table.raw_data
							this.items.push(itemsIon)
							//itemsIon.push(parseInt(this.caso.esquemas[i].value))
							this.$vs.loading.close('#resultados > .con-vs-loading')
						}
					}
					this.$vs.loading.close('#resultados > .con-vs-loading')
					this.items.sort((a, b) => (a.MensualidadPromedio > b.MensualidadPromedio ? 1 : b.MensualidadPromedio > a.MensualidadPromedio ? -1 : 0))
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un errros en apiIon',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
		createSolicitante() {
			let self = this
			var objRequestRegistraSolicitante = {
				strApiKey: this.key,
				strMetodo: 'RegistraSolicitante',
				objSolicitante: {
					EMail: this.mail,
					Nombres: this.name,
					ApellidoPaterno: this.firstname,
					ApellidoMaterno: this.lastname,
					TelefonoCelular: this.phone,
					FechaNacimiento: '1992-01-01',
					// StateData: 0,
				},
			}

			this.$axios
				.post('/', objRequestRegistraSolicitante, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {
					if (response.data.intEstatus == 0) {
						this.saveSolicitante(this.mail)
						this.savePhone(this.phone)
						document.getElementById('destinos').removeAttribute('hidden')
						document.getElementById('contacto').hidden = true
						//this.$emit('nextTab',true)
					}
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error en RegistraSolicitante',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
		validamonto() {
			this.valores.valor = this.valores.valor.toString().match(/^-?\d*(?:\.\d{0,2})?/)[0]

			var valor2 = parseInt(this.valores.valor)

			if (valor2.toString().length < 6 || this.valores.valor == '') {
				this.valores.valor = 100000
			}

			if (valor2.toString().length > 9) {
				this.valores.valor = 999999999
			}
			this.valores.valor = parseFloat(this.valores.valor).toFixed(2)
		},
		validacreditomonto() {
			this.valores.credito = this.valores.credito.toString().match(/^-?\d*(?:\.\d{0,2})?/)[0]
			var valor2 = parseInt(this.valores.credito)

			if (valor2.toString().length < 6 || this.valores.credito == '') {
				this.valores.credito = 100000
			}

			if (valor2.toString().length > 9) {
				this.valores.credito = 999999999
			}
			this.valores.credito = parseFloat(this.valores.credito).toFixed(2)
		},
		validamensualidad() {
			this.valores.mensualidad = this.valores.mensualidad.toString().match(/^-?\d*(?:\.\d{0,2})?/)[0]

			var valor2 = parseInt(this.valores.mensualidad)

			if (valor2.toString().length < 4 || this.valores.mensualidad == '') {
				this.valores.mensualidad = 1000
			}

			if (valor2.toString().length > 8) {
				this.valores.mensualidad = 99999999
			}
			this.valores.mensualidad = parseFloat(this.valores.mensualidad).toFixed(2)
		},
		validaplazos() {
			// alert(this.valores.esquemasACotizar)
			let self = this
			let objRequestDamePlazos = {
				strApiKey: this.key,
				strMetodo: 'ListaBancosPlazos',
				objCaso: {
					Esquema: this.valores.esquemasACotizar,
					Plazos: this.valores.plazosACotizar,
				},
			}
			this.$axios
				.post('/', objRequestDamePlazos, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error en DamePlazos',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
		cambiaBancos() {
			//alert("hola");

			if (this.valores.plazosACotizar != '' && this.valores.esquemasACotizar != '') {
				this.bancos = []
				this.caso.bancos = []
				this.caso.plazos = []
				this.caso.esquemas = []

				for (var i = 0; i < this.valores.plazosACotizar.length; i++) {
					if (typeof this.valores.plazosACotizar[i] == 'object') {
						this.caso.plazos.push(this.valores.plazosACotizar[i].value)
					} else {
						this.caso.plazos.push(this.valores.plazosACotizar[i].substring(0, 2))
					}
				}

				let self = this
				let objRequestDamePlazos = {
					strApiKey: this.key,
					strMetodo: 'ListaBancosPlazos',
					objCaso: {
						Esquema: this.valores.esquemasACotizar,
						Plazos: this.caso.plazos,
					},
				}
				this.$axios
					.post('/', objRequestDamePlazos, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
					.then((response) => {
						if (response.data.intEstatus == 0) {
							let bancos = response.data.objContenido
							for (var i = 0; i < bancos.length; i++) {
								this.bancos.push({ label: bancos[i].Nombre, value: bancos[i].Id })
							}
							this.caso.bancos = this.bancos //cambio bancos
							this.bancosEjecutivo = this.bancos
						} else {
							this.$vs.notify({
								title: 'Ocurrio un error en ListaFinancieras',
								text: response.data.strError,
								color: 'danger',
								position: 'top-right',
							})
						}
					})
					.catch(function (error) {
						self.$vs.notify({
							title: 'Ocurrio un error en DamePlazos',
							text: error,
							color: 'danger',
							position: 'top-right',
						})
					})
			}
		},
		getValues() {
			let self = this
			let objRequestDameSolicitante = {
				strApiKey: this.key,
				strMetodo: 'MisDatos',
			}
			this.$axios
				.post('/', objRequestDameSolicitante, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } })
				.then((response) => {

					if (response.data.intEstatus == 0) {
						let data = response.data.objContenido
						if (data.WidgetColorPrimario !== '' && data.WidgetColorPrimario !== null) {
							this.$vs.theme({
								primary: data.WidgetColorPrimario,
							})
						}
						if (data.Imagen !== '' && data.Imagen !== null) {
							this.logoHeader = 'https://cotizador.socasesores.com/uploads/' + data.WidgetImagen
							this.logoHeader = data.Imagen
						}

						this.TipoEjecutivoV3 = data.TipoEjecutivoV3
					}
				})
				.catch(function (error) {
					self.$vs.notify({
						title: 'Ocurrio un error en MisDatos',
						text: error,
						color: 'danger',
						position: 'top-right',
					})
				})
		},
	},
}
</script>

<style media="screen">
.header {
	display: block;
	margin-left: auto;
	width: 100%;
	height: 70px;
	margin-top: 0%;
	margin-bottom: 5%;
	display: flex;
}
.logo {
	/*width: 165px;*/
	max-height: 60px;
}
.logo_soc {
	margin-right: -26px;
	margin-left: 20px;
	display: flex;
	align-items: center;
}
.logo_eje {
	/*width: 131px ;*/
	height: 60px;
	border-left: 2px solid #44516d;
	margin-bottom: -84px;
	padding-left: 23px;
	margin-left: 47px;
	display: flex;
	align-items: center;
}
.router-content {
	margin-top: 0% !important;
}
.label-lg {
	width: 100%;
	margin-bottom: -7px;
}
.margin-col {
	padding-top: 10px !important;
	padding-right: 20px;
}
@media screen and (max-width: 720px) {
	.logo {
		max-height: 31px;
	}
}
@media screen and (max-width: 560px) {
	.margin-col {
		padding-top: 10px !important;
		padding-right: 0px;
	}
	.wizard-tab-content {
		padding: 20px;
		max-width: 900px;
		height: 759px;
	}
}
@media screen and (max-width: 414px) {
	.logo_eje {
		margin-bottom: 0;
	}
}
@media screen and (max-width: 280px) {
	.logo {
		max-height: 31px;
		/*width: 140px;*/
	}
	.logo_eje {
		margin-top: -19px;
		border: none;
	}
	.logo_soc {
		margin-right: -111px;
		margin-left: 20px;
	}
	button.wizard-btn {
		margin-top: -1604px !important;
		margin-left: -127px;
		width: 120px;
	}
	.wizard-tab-content {
		max-width: 900px;
		height: 720px;
	}
}
</style>
